<div class="flex flex-fill flex-col flex-gap-standard page-border">
    @if (showPlangebiet()) {
        <app-page-panel class="flex-fit" 
            [showBackButton]="false"
            iconNameFontAwesome="assistant_navigation"
            pageTitle="Plangebiet"
            [showBackColor]="true"
            [showDetailsButton]="false"
            [showSidepanelButton]="false"
			(iconMenuButtonClicked)="navigationService.toggleSidepanelInfo()">
		    <div class="flex flex-fill flex-col flex-stretch-self flex-center image-height">
                @if (projektInfo().plangebiet=='HafenCity') {
                    <div class="flex flex-fill flex-col flex-stretch-self flex-center image-height backcolor-plangebiet-HCH image-corner">
                        <img class="image-fit backcolor-primary" ngSrc="assets/logos/hafencity_logo.png" width="292" height="57" priority>
                    </div>  
                }
                @else if (projektInfo().plangebiet=='Billebogen') {
                    <img class="image-fit" ngSrc="assets/logos/billebogen_logo.png" width="292" height="74" priority>
                }
                @else if (projektInfo().plangebiet=='Grasbrook') {
                    <img class="image-fit" ngSrc="assets/logos/grasbrook_logo.png" width="292" height="85" priority>
                }
                @else if (projektInfo().plangebiet=='Science City') {
                    <div class="flex flex-fill flex-col flex-stretch-self flex-center image-height backcolor-plangebiet-SCHB image-corner">
                        <img class="image-fit" ngSrc="assets/logos/sciencecity_logo.png" width="292" height="100" priority>
                    </div>
                }  
            </div>
        </app-page-panel>
    }
    <app-page-panel
        class="flex-fill" 
        [showBackButton]="false"
        iconNameIonicon="filing"
        pageTitle="Projekt"    
        [showBackColor]="true"
        [showDetailsButton]="false"
        [showSidepanelButton]="false"
        [resizeContent]="true">
        <div class="flex flex-fill flex-col flex-stretch-self content-justify  page-padding">
            <mat-form-field class="form-field-remove-hint" appearance="fill">
                <mat-label>Projektname</mat-label>
                <input matInput readonly [value]="projektInfo().name">
            </mat-form-field>
            <div class="flex flex-row flex-stretch-self flex-gap-12">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Controlling</mat-label>
                        <input matInput readonly [value]="projektInfo().controllingbereich">
                    </mat-form-field>
                </div>
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Plangebiet</mat-label>
                        <input matInput readonly [value]="projektInfo().plangebiet">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row flex-stretch-self flex-gap-12">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Quartier</mat-label>
                        <input matInput readonly [value]="projektInfo().quartier">
                    </mat-form-field>
                </div>
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Klassifizierung</mat-label>
                        <input matInput readonly [value]="projektInfo().klassifizierung">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row flex-stretch-self flex-gap-12">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Projektmanager</mat-label>
                        <input matInput readonly [value]="projektInfo().projektmanager">
                    </mat-form-field>
                </div>
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill">
                        <mat-label>Projektsteuerer</mat-label>
                        <input matInput readonly [value]="projektInfo().projektsteuerer">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row flex-stretch-self flex-gap-12">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill" class="form-field-remove-hint">
                        <mat-label>Kostengruppe</mat-label>
                        <input matInput readonly [value]="projektInfo().kostengruppe">
                    </mat-form-field>
                </div>
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill" class="form-field-remove-hint">
                        <mat-label>Kostenstelle</mat-label>
                        <input matInput readonly [value]="projektInfo().kostenstelle">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row flex-stretch-self flex-gap-12">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill" class="form-field-remove-hint">
                        <mat-label>Akt. Bearbeitung</mat-label>
                        <input matInput readonly [value]="projektInfo().bearbeiter">
                    </mat-form-field>
                </div>
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" appearance="fill" class="form-field-remove-hint">
                        <mat-label>Status</mat-label>
                        <input matInput readonly [value]="projektInfo().status">
                    </mat-form-field>
                </div>
            </div>
        </div>

    </app-page-panel>
    <app-page-panel 
        class="flex-fit" 
        [showBackButton]="false"
        iconNameFontAwesome="incomplete_circle"
        pageTitle="Projekt Soll / Ist"    
        [showBackColor]="false"
        [showDetailsButton]="false"
        [showSidepanelButton]="false">
        <div class="flex flex-fill flex-gap-standard flex-col flex-stretch-self">
            <app-element-panel 
                pageTitle="Ist-Kosten / Akt. Budget">
                <div class="flex flex-col flex-stretch-self">
                    <div class="flex flex-row flex-stretch-self progress-height">
                        @if (projektInfo().budgetaktuell !== 0) {
                            <span class="page-panel-header-title font-subtitle-contrast cell-left color-primary-contrast" [ngStyle]="{'width': istKostenValue() + '%'}">{{istKostenValue()}}%</span>
                            <span class="page-panel-header-title font-subtitle-contrast cell-right" [ngStyle]="{'width': 100 - istKostenValue() + '%'}">{{100 - istKostenValue()}}%</span>
                        }
                    </div>
                    <mat-progress-bar class="progress-bar" mode="determinate" value="{{istKostenValue()}}"></mat-progress-bar>
                </div>
            </app-element-panel>
            <app-element-panel 
                pageTitle="Auftragswerte / Akt. Budget ">
                <div class="flex flex-col flex-stretch-self">
                    <div class="flex flex-row flex-stretch-self progress-height">
                        @if (projektInfo().budgetaktuell !== 0) {
                            <span class="page-panel-header-title font-subtitle-contrast cell-left color-primary-contrast" [ngStyle]="{'width': auftragswertValue() + '%'}">{{auftragswertValue()}}%</span>
                            <span class="page-panel-header-title font-subtitle-contrast cell-right" [ngStyle]="{'width': 100 - auftragswertValue() + '%'}">{{100 - auftragswertValue()}}%</span>
                        }
                    </div>
                    <mat-progress-bar class="progress-bar" mode="determinate" value="{{auftragswertValue()}}"></mat-progress-bar>
                </div>
            </app-element-panel>
        </div>
    </app-page-panel>
</div>
